import React from "react";

const Education = () => {
  return (
    <>
      <section className="education-section">
        <h1>Education</h1>

        <ul className="education-list">
          <li>
            <h2>Skill-Up </h2>
            <h3>Front-End Development</h3>
            <p>June 2021 - October 2021 | Ukraine</p>
          </li>
          <li>
            <h3>Ivan Franko National University of Lviv</h3>
            <h4>Law (Magister's degree)</h4>
            <p>September 2016 - June 2017 | Ukraine</p>
          </li>
          <li>
            <h3>Taras Shevchenko National University of Kyiv</h3>
            <h4>Law (Bachelor's degree)</h4>
            <p>September 2011 - June 2016 | Ukraine</p>
          </li>
        </ul>
      </section>
    </>
  );
};
export default Education;
